// The People page's Category menu, grouped as /Videos' Session menu (Seán, 2026-11-03): the
// event's kinds of talk, Showcase with Art & Biology, the six topic sessions, Tech-Track and any
// other track, then the three deliveries (In person, Online, Virtual: each a person's sessions of
// that kind, not each session), then the attendee sections; only what someone on the page has
// (the galleries report their sessions), each group's order fixed, a line under every group but
// the last (Dropdown.vue's separators).
import {useSortSessionNames} from "@/composables/useSortSessionNames";

const KINDS = ["Keynote", "Masterclass"];
const ARTS = ["Showcase", "Art & Biology"]; // one group (Seán, 2026-11-03)
const LEFT_OUT = ["Shorts"]; // not a category of people (Seán, 2026-11-03)
const TOPICS = ["DNA", "RNA", "Proteins", "Cells", "Tissues", "Ecosystems"];
const FIXED = [...KINDS, ...ARTS, ...TOPICS];
const DELIVERY_PREFIX = /^(Online|Virtual) /; // "Online Masterclass", "Virtual Workshop"
export const DELIVERIES = ["In person", "Online", "Virtual"];

const getIsInPerson = (session) => {
  return !DELIVERY_PREFIX.test(session) && session !== "Tech-Track" && !LEFT_OUT.includes(session);
};

// whether a person's sessions match a category of the menu: a delivery, or one session whole
export function getMatchesCategory(sessions, category) {
  if (category === "Online") return sessions.some((session) => /^Online /.test(session));
  if (category === "Virtual") return sessions.some((session) => /^Virtual /.test(session));
  if (category === "In person") return sessions.some(getIsInPerson);
  return sessions.includes(category);
}

// the deliveries the page's sessions have, in their order
function getDeliveries(sessions) {
  return DELIVERIES.filter((delivery) => sessions.some((session) => {
    return getMatchesCategory([session], delivery);
  }));
}

// the groups that have something, in order: [names, …]
function getGroups(sessions, attendeeLabels) {
  const kinds = KINDS.filter((name) => sessions.includes(name));
  const arts = ARTS.filter((name) => sessions.includes(name));
  const topics = TOPICS.filter((name) => sessions.includes(name));
  const isTrack = (name) => !FIXED.includes(name) && !LEFT_OUT.includes(name)
    && !DELIVERY_PREFIX.test(name);
  const tracks = useSortSessionNames(sessions.filter(isTrack));
  const groups = [kinds, arts, topics, tracks, getDeliveries(sessions), attendeeLabels];
  return groups.filter((group) => group.length);
}

// {options, separators}: the menu's items, and the last of each group but the last
export function getSessionMenu(sessions, attendeeLabels = []) {
  const groups = getGroups(sessions, attendeeLabels);
  const separators = groups.slice(0, -1).map((group) => group.at(-1));
  return {options: groups.flat(), separators};
}
